import { LinearGradient } from 'expo-linear-gradient';
import React, { FC, PropsWithChildren } from 'react';
import { Gradient } from '../../config/designSystem/Colors';
import { StyleProp, ViewStyle } from 'react-native';

export interface GradientViewProps extends PropsWithChildren {
    gradient: Gradient;
    style?: StyleProp<ViewStyle> | undefined;
}

const angleToPoints = (angleDeg: number) => {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    start: { x: 0.5 - 0.5 * Math.sin(rad), y: 0.5 + 0.5 * Math.cos(rad) } as const,
    end: { x: 0.5 + 0.5 * Math.sin(rad), y: 0.5 - 0.5 * Math.cos(rad) } as const,
  };
};

export const GradientView : FC<GradientViewProps>= ({gradient, children, style} ) => {
  const { start, end } = angleToPoints(gradient.orientationAngle);

  return (
    <LinearGradient
      colors={[gradient.left, gradient.right]}
      start={start}
      end={end}
      style={style}
    >
      {children}
    </LinearGradient>
  );
};
